import { useQuery } from "@tanstack/react-query";
import { BreakerRoutes, CustomerRoutes } from "appRoutePaths";
import { SideMenuEntry } from "components/Navigation/SideMenu/sideMenuEntries";
import { Roles } from "context/auth";
import { useAuthenticatedRequest } from "./useRequests";
import { UnreadTicketsKeyPrefix } from "./useSupportTickets";
import useDeviceNotifications from "./useDeviceNotifications";

const Dashboard: SideMenuEntry = {
    name: "Dashboard",
    url: CustomerRoutes.dashboard.url,
    icon: require("images/icons/icon_dashboard.svg"),
};
const Profile: SideMenuEntry = {
    name: "Profile",
    url: CustomerRoutes.profile.url,
    icon: require("images/icons/icon_packages.svg"),
};
const Packages: SideMenuEntry = {
    name: "My Submissions",
    url: CustomerRoutes.packages.url,
    icon: require("images/icons/icon_packages.svg"),
};
const Cards: SideMenuEntry = {
    name: "My Cards",
    url: CustomerRoutes.cards.url,
    icon: require("images/icons/icon_cards.svg"),
};
const Transactions: SideMenuEntry = {
    name: "Transactions",
    url: CustomerRoutes.transactions.url,
    icon: require("images/icons/icon_transactions.svg"),
};
const RequestPayout: SideMenuEntry = {
    name: "Request Payout",
    url: CustomerRoutes.requestPayout.url,
    icon: require("images/icons/icon_payout.svg"),
};
const Support: SideMenuEntry = {
    name: "Support",
    url: CustomerRoutes.support.url,
    icon: require("images/icons/icon_support.svg"),
};

/*
const Shop: SideMenuEntry = {
    name: "Shop",
    url: CustomerRoutes.shop.url,
    icon: require("images/icons/icon_start_selling.svg"),
};
*/

const BreakerPortal: SideMenuEntry = {
    name: "Breaker Portal",
    url: BreakerRoutes.portal.url,
    icon: require("images/icons/icon_dashboard.svg"),
};

const Breakers: SideMenuEntry = {
    name: "Breakers",
    url: CustomerRoutes.breakers.url,
    icon: require("images/icons/icon_dashboard.svg"),
};

const useUnreadTicketCount = (enabled: boolean) => {
    const count = useAuthenticatedRequest<{ count: number }>({
        method: "get",
        url: "/support/tickets/unread/count",
    });

    return useQuery([...UnreadTicketsKeyPrefix, "count"], count, { enabled });
};

const useCustomerMenuItems = (
    roles: Roles[],
    enabled = true,
): SideMenuEntry[] => {
    const { data, isLoading } = useUnreadTicketCount(enabled);
    const { data: tickets } = useDeviceNotifications();
    const notificationsCount =
        tickets && data ? tickets?.extra.unreadCount + data?.count : 0;

    const extendedSupport = isLoading
        ? Support
        : { ...Support, count: notificationsCount };

    const menuItems = [
        Dashboard,
        Profile,
        // Shop,   removed per Tory's request (mtighe 2026/01/05: https://infernored.slack.com/archives/C0932UQ3QQN/p1767382736156509)
        Packages,
        Cards,
        Transactions,
        RequestPayout,
        extendedSupport,
    ];

    if (roles.includes(Roles.Breaker)) {
        menuItems.push(BreakerPortal);
    } else {
        menuItems.push(Breakers);
    }

    return menuItems;
};

export default useCustomerMenuItems;
